import { useEffect, useRef, useState } from 'react';
import { supabase } from './supabaseClient';

// Każda instancja hooka musi mieć własny kanał — Supabase rzuca błędem,
// gdy do już zasubskrybowanego kanału o tej samej nazwie dopina się kolejne callbacki
// (np. Header i strona „Nasze psy" słuchają tej samej tabeli).
let channelSeq = 0;

// Pobiera dane z Supabase i utrzymuje je aktualne „na żywo":
//  - odświeża po powrocie do karty (focus / widoczność),
//  - subskrybuje zmiany w tabeli (Supabase Realtime) — natychmiastowy push,
//  - lekki polling co 30 s jako zabezpieczenie (gdy Realtime nie jest włączony).
// Dopóki brak danych z bazy (ładowanie / pusto / brak sieci) używa danych zapasowych.
export function useSupabaseData(fetchFn, fallback, table) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const fnRef = useRef(fetchFn);
  fnRef.current = fetchFn;

  useEffect(() => {
    let alive = true;

    const load = () =>
      Promise.resolve()
        .then(() => fnRef.current())
        .then((res) => {
          if (!alive) return;
          const hasData = Array.isArray(res) ? res.length > 0 : Boolean(res);
          if (hasData) setData(res);
        })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });

    load();

    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);

    let channel;
    if (table && supabase) {
      channel = supabase
        .channel(`rt-${table}-${++channelSeq}`)
        .on('postgres_changes', { event: '*', schema: 'public', table }, () => load())
        .subscribe();
    }

    const poll = setInterval(() => { if (document.visibilityState === 'visible') load(); }, 30000);

    return () => {
      alive = false;
      clearInterval(poll);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
      if (channel && supabase) supabase.removeChannel(channel);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table]);

  return { data, loading };
}
